/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APITypeRequest
 */
export interface APITypeRequest {
    /**
     * 
     * @type {string}
     * @memberof APITypeRequest
     */
    name: string;
}

/**
 * Check if a given object implements the APITypeRequest interface.
 */
export function instanceOfAPITypeRequest(value: object): value is APITypeRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APITypeRequestFromJSON(json: any): APITypeRequest {
    return APITypeRequestFromJSONTyped(json, false);
}

export function APITypeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APITypeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function APITypeRequestToJSON(value?: APITypeRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

